module.exports = __webpack_public_path__ + "img/sphere05-graph-black.7b329673.png";